<template>
  <div id="loader"
    v-if="isLoaderActive">
    <div class="board">
      <div class="icon"><font-awesome-icon :icon="['fal', 'spinner-third']" spin /></div>
      <div class="messages">
        <p class="body-1">{{ printLoaderMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  computed: {
    isLoaderActive () {
      return this.$store.getters['loader/isActive']()
    },
    printLoaderMessage () {
      return this.$store.getters['loader/printMessage']()
    }
  }
}
</script>

<style lang="scss">
#loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, .4);
  color: #FFF;
  z-index: 99;

  .board {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 200px;
    height: 200px;
    background: rgba(#000, .8);
    padding: 1rem;
    .icon {
      font-size: 8rem;
    }
  }
}
</style>
